let Image_Error;

Image_Error = (() => {
    class Image_Error {
        constuctor() {
            return $(document).ready(() => $(".icon img").on("error", function(
                e,
            ) {
                return noun.icon_list.fallbackIcon($(this));
            }));
        }
    }

    return Image_Error;
})();

export default new Image_Error();
